import { WA_NUMBER } from './products'

export interface Combo {
  id: number
  name: string
  products: string[]
  comboPrice: number
  individualPrice: number
  savings: number
  image: string
  pain: string
  benefit: string
  waMessage: string
}

export const combos: Combo[] = [
  {
    id: 1,
    name: 'Combo Fuerza + Masa',
    products: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    comboPrice: 1690,
    individualPrice: 1980,
    savings: 290,
    image:
      'https://cdn.magicpatterns.com/uploads/g2gkabWXWwXzgMAADaGtf5/Isolate_protein_mix_y_creatine_powder.jpg',
    pain: 'El atleta que quiere ganar músculo y fuerza pero gasta de más comprando cada suplemento por separado.',
    benefit:
      'Proteína de alta calidad + creatina pura en un solo combo económico para crecer más rápido.',
    waMessage:
      'Hola! Quiero el Combo Fuerza + Masa — Isolate Protein Mix 900g + Creatine POWER 300g por $1.690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 2,
    name: 'Combo Volumen Total',
    products: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine 100% Pure 250g (Profit)',
      'Vaso Shaker 750ml (Profit)',
    ],
    comboPrice: 2290,
    individualPrice: 2470,
    savings: 180,
    image:
      'https://cdn.magicpatterns.com/uploads/wcaSN7P9sHv9huJ2y6WQ3g/Anabolic_y_Creatine_100_pure.jpg',
    pain: 'El hardgainer que no puede subir de peso sin importar cuánto come o entrena.',
    benefit:
      'El stack completo para ganar masa muscular real, con el shaker incluido para prepararlo en cualquier momento.',
    waMessage:
      'Hola! Quiero el Combo Volumen Total — Anabolic MASS 28500 3kg + Creatine 100% Pure 250g + Vaso Shaker 750ml por $2.290 UY. ¿Tienen stock disponible?',
  },
  {
    id: 3,
    name: 'Combo Masa + Potencia',
    products: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine POWER 300g (Profit)',
      'Vaso Shaker 750ml (Profit)',
    ],
    comboPrice: 1990,
    individualPrice: 2570,
    savings: 580,
    image:
      'https://cdn.magicpatterns.com/uploads/n3Z3JS1Ba1NW8xRvB1rGQx/Isolate_protein_mix_y_creatine_power.jpg',
    pain: 'Querés ganar volumen muscular y potencia explosiva pero no podés costear ambos suplementos por separado.',
    benefit:
      'Calorías de calidad + creatina potente + shaker incluido. Todo lo que necesitás para explotar en el gym.',
    waMessage:
      'Hola! Quiero el Combo Masa + Potencia — Anabolic MASS 28500 3kg + Creatine POWER 300g + Vaso Shaker 750ml por $1.990 UY. ¿Tienen stock disponible?',
  },
  {
    id: 4,
    name: 'Combo Alpha Cibeles',
    products: [
      'Power Whey Protein 2LB (Cibeles)',
      'Creatina CREAPURE Cibeles 350g (Cibeles)',
    ],
    comboPrice: 4690,
    individualPrice: 4880,
    savings: 190,
    image:
      'https://cdn.magicpatterns.com/uploads/fEGGn5T6NCa8fNJWctvSec/Whey_protein_y_creatina_350g.jpg',
    pain: 'Querés los mejores suplementos del mercado uruguayo pero el precio individual te frena.',
    benefit:
      'La combinación más poderosa de proteína + creatina certificada CREAPURE para resultados visibles en semanas.',
    waMessage:
      'Hola! Quiero el Combo Alpha Cibeles — Power Whey Protein 2LB + Creatina CREAPURE Cibeles 350g por $4.690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 5,
    name: 'Combo Alpha PRO Cibeles',
    products: [
      'Power Whey Protein 2LB (Cibeles)',
      'Creatina CREAPURE Cibeles 500g (Cibeles)',
    ],
    comboPrice: 4990,
    individualPrice: 5380,
    savings: 390,
    image:
      'https://cdn.magicpatterns.com/uploads/aXucFdjMkxa2AmtGNs6f89/Whey_protein_y_creatina_500g.jpg',
    pain: 'Atleta serio que no quiere quedarse sin suplementos a mitad del mes y necesita el stack más completo disponible.',
    benefit:
      'Más creatina CREAPURE por más tiempo, combinada con proteína premium para el atleta que va en serio y no para.',
    waMessage:
      'Hola! Quiero el Combo Alpha PRO Cibeles — Power Whey Protein 2LB + Creatina CREAPURE Cibeles 500g por $4.990 UY. ¿Tienen stock disponible?',
  },
]
